import { useMemo, useState } from "react";
import { products } from "@/data/products";
import ProductGrid from "@/components/ProductGrid";

const Category = ({ category }) => {
  const [gender, setGender] = useState("all"); // all | Men | Women

  const filtered = useMemo(() => {
    const inCat = products.filter((p) => p.category === category);
    if (gender === "all") return inCat;
    return inCat.filter((p) => p.gender === gender);
  }, [category, gender]);

  const btn = (value, label) => {
    const active = gender === value;
    return (
      <button
        key={value}
        onClick={() => setGender(value)}
        data-testid={`filter-${value.toLowerCase()}`}
        style={{
          padding: "10px 18px",
          borderRadius: 8,
          border: `1px solid ${active ? "#0F766E" : "#E5E7EB"}`,
          background: active ? "#0F766E" : "#FFFFFF",
          color: active ? "#FFFFFF" : "#111827",
          fontWeight: 600,
          cursor: "pointer",
          transition: "all 0.2s ease",
        }}
      >
        {label}
      </button>
    );
  };

  return (
    <div className="container-vzor" style={{ paddingTop: 40, paddingBottom: 64 }} data-testid={`category-page-${category.toLowerCase()}`}>
      <h1
        style={{
          fontSize: 40,
          fontWeight: 700,
          letterSpacing: "-0.02em",
          margin: "0 0 20px 0",
        }}
        data-testid="category-heading"
      >
        {category}
      </h1>

      <div style={{ display: "flex", gap: 10, marginBottom: 28, flexWrap: "wrap" }}>
        {btn("all", "All")}
        {btn("Men", "Men")}
        {btn("Women", "Women")}
      </div>

      {filtered.length === 0 ? (
        <p style={{ color: "#6B7280" }}>No products found.</p>
      ) : (
        <ProductGrid items={filtered} testId={`grid-${category.toLowerCase()}`} />
      )}
    </div>
  );
};

export default Category;
